export default __webpack_public_path__ + "static/JSgirls_logo-41035e878593aa0f70dba0708b5fb8b6.svg";